
          export const webcrypto = globalThis.crypto;
          export function randomBytes(length) {
            const bytes = new Uint8Array(length);
            globalThis.crypto.getRandomValues(bytes);
            return bytes;
          }
        